<script >
import {common, shortUrl} from "@/api";
import commonStore from "@/store/common";
import shotUrlStore from "@/store/shotUrl";

export default {
  async created() {
    await this.fetchData()
  },
  methods: {
    getCommonCode(code) {
      return common.getCommonCode(commonStore.state.common.corpCode, [code])
          .then(data => {
            console.log(data)
            const codes = [];
            if (data.data.codes) {
              data.data.codes.forEach(item => {
                codes.push({detail: item.detail, detail_name: item.detail_name})
              })
            }
            return codes
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
            }
            return []
          })
    },
    fetchData() {
      return shortUrl.search(this.$route.params.shortPath)
          .then(data => {
            var uri = '/';

            if (data.data) {
              this.getCommonCode('CI001')
                  .then(commonCodes => {
                    var corp = commonCodes.find(v => v.detail === data.data.corp_code)
                    commonStore.dispatch('setCorpCode', corp)
                        .then(() => {
                          if (data.data.entry_display) { // 원래 uri
                            uri = uri + data.data.entry_display
                            if (data.data.option1) { // 업장
                              uri = uri + '/' + data.data.option1
                              if (data.data.option2) { // 업장의 상품
                                uri = uri + '/' + data.data.option2
                              }
                            }

                            if (data.data.use_type) { // 업장 탭
                              shotUrlStore.dispatch('setRouterInfo', {upjangTab: data.data.use_type})
                              uri = uri + '?tab=' + data.data.use_type
                            }
                            if (data.data.calc_types) { // 업장별 결제수단
                              shotUrlStore.dispatch('setRouterInfo', {calcTypes: data.data.calc_types})
                            }
                            if (data.data.rcv_types) { // 업장별 수령정보
                              shotUrlStore.dispatch('setRouterInfo', {rcvTypes: data.data.rcv_types})
                            }
                            if (this.$route.params.dynamicParam) { // 다이나믹파라미터
                              shotUrlStore.dispatch('setRouterInfo', {dynamicParam: this.$route.params.dynamicParam.substring(6)})
                              shotUrlStore.dispatch('setRouterInfo', {dynamicParamUpjang: this.$route.params.dynamicParam.substring(0,6)})
                            }
                          }

                          console.log('uri', uri)

                          console.log("shotUrlStore.state.routerInfo")
                          console.log(shotUrlStore.state.routerInfo)

                          this.$router.push(uri)
                              .then(() => {
                                console.log("shotUrlStore.state.routerInfo")
                                console.log(shotUrlStore.state.routerInfo)
                                location.reload();
                              });
                        })
                  })
            }
          })
          .catch(err => {
            console.log(err)
            // alert("에러가 발생했습니다.")
            // this.$router.push('/')
          })
    },
  }
}

</script>